// TODO:  evolve getBreadcrumb to allow different breadcrumb sizes in shared seo lib @jardelbaia
import { makeId } from '@jusbrasil-web/shared-utils-seo'

import { ARTIFACT_LABELS } from '../constants'
import { ArtifactLabels } from '../types'

export const getBreadcrumb = ({
  url,
  title,
  courtAcronym,
  publisherUrl,
  artifactLabel = ARTIFACT_LABELS.JURISPRUDENCIA,
}: {
  url: string
  title: string
  courtAcronym?: string
  publisherUrl?: string
  artifactLabel?: ArtifactLabels
}) => {
  const itemListElement = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: 'https://www.jusbrasil.com.br',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: artifactLabel.pluralLabel,
      item: `https://www.jusbrasil.com.br/${artifactLabel.path}/`,
    },
  ]

  if (artifactLabel === ARTIFACT_LABELS.JURISPRUDENCIA) {
    itemListElement.push({
      '@type': 'ListItem',
      position: 3,
      name: courtAcronym || '',
      item: publisherUrl || '',
    })
  }

  return {
    '@id': makeId(url, 'breadcrumb'),
    '@type': 'BreadcrumbList',
    itemListElement: [
      ...itemListElement,
      {
        '@type': 'ListItem',
        position: 4,
        name: title,
        item: url,
      },
    ],
  }
}
